export default __webpack_public_path__ + "static/media/express.1387d6c1.svg";